// extracted by mini-css-extract-plugin
export default {"root":"JuryMemberCard_root__btg6L","image":"JuryMemberCard_image__GEiYk","title":"JuryMemberCard_title__Snt1O","description":"JuryMemberCard_description__faSJu"};